import { RESET, SET_SELECTED_SORTING_OPTION } from "./sortFilter.actionTypes";

const initialState = {
  selectedSortingOption: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_SORTING_OPTION: {
      return { ...state, selectedSortingOption: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
